
import { defineComponent } from 'vue';

export default defineComponent({
    name: "AboutSection",

    data(){
        return{
            
        } 
    },

    methods:{



    }

});
